/**
 * Localhost environment
 */
export const LOCALHOST = 'LOCALHOST' as const;

/**
 * Production environment
 */
export const PROD = 'PROD' as const;

/**
 * Staging environment
 */
export const STG = 'STG' as const;

/**
 * Environments
 */
export const ENVIRONMENT = {
  LOCALHOST,
  PROD,
  STG,
} as const;
